import React from 'react';
import {MetricsElement} from 'react-metrics';

import { Helpers } from '../../core/src/helpers';
import { Carousel, setCarouselHeight } from '../../shared/components/carousel';
import CarouselIndicator from '../../shared/components/carousel-indicator';
import NavArrow from '../../shared/components/nav-arrow';
import LazyLoadImage from '../../shared/components/lazyload-image';
import Link from '../../shared/components/hyperlink';

import '../css/product-image.less';

export const OptimizeProductImageWrapper = (Component) => {
    return class extends React.Component {
        generateImages = Helpers.memoize((sku, productImages=[], defaultImages, maxImgWidth=570, imagesToShow) => {
            let images = [];
            let arrayLength = imagesToShow >= 0 ? imagesToShow : productImages.length;
        
            for (let i = 0; i < arrayLength; i++) {
                if (!productImages || images.length === 4) {
                    break;
                }
                else if(!productImages[i].isAnnotated && productImages[i].type !== 'video'){
                    let primaryImage = productImages[i].cdn;
                    try{
                        if(defaultImages > 0 && productImages[i].altImages && productImages[i].altImages.length > 0){
                            primaryImage = productImages[i].altImages[defaultImages - 1].lrg;
                        }
                    }catch(e){
                        //catch an exceptions with alt images
                    }
                    images.push(Helpers.getCDNUrl(primaryImage, productImages[i].lrg,maxImgWidth));
                }
            }
        
            return images;
        },(sku, productImages=[], defaultImages, maxImgWidth=570, imagesToShow) => `${sku}${productImages.length}${defaultImages}${maxImgWidth}${imagesToShow}`)

        render() {
            const { product={}, maxImgWidth, imagesToShow, ...rest } = this.props;
            const { images=[], defaultImages, sku, name } = product;
            const optImages = this.generateImages(sku, images, defaultImages, maxImgWidth, imagesToShow);
            return (
                <Component images={optImages} title={product.name} {...rest} />
            );
        }
    }
}

class ProductImage extends React.Component {

    constructor(props) {
        super(props);
        this.imageList = this.imageList.bind(this);
        this.changeSlide = this.changeSlide.bind(this);
        this.state = {
            slideIndex: 0
        }
    }

    

    componentDidUpdate(prevProps) {
        if (this.props.link !== prevProps.link) {
            this.changeSlide(0);
        };
    }

    changeSlide(index) {
        this.setState({slideIndex: index});
    }

    controls() {
		return {
			renderCenterLeftControls : NavArrow.PrevArrow,
			renderCenterRightControls: NavArrow.NextArrow,
            renderBottomCenterControls: CarouselIndicator,
		}
    }

    imageList() {
        let className = 'actual-image ' + (this.props.grow ? 'grow' : '');
		let { images, tabIndex=null, lazyLoad=true, title, productClickMetrics } = this.props;
        return (
            images.map((image, i) => {
                const imgProps = {
                    onLoad: i === 0 ? () => setCarouselHeight(this.carousel) : null,
                    onClick:this.props.onClick,
                    className:className,
					src: image, 
					alt: title
                }

                const productClickMetricProps = typeof productClickMetrics === 'object' && productClickMetrics ? productClickMetrics : {};
                return (<div tabIndex={-1} aria-label={title} className='pdt-img-aspect' key={i}>
                    <MetricsElement>
                        <Link tabIndex={-1} to={this.props.link} linkType={this.props.linkType} {...productClickMetricProps}>
                            {lazyLoad ? <LazyLoadImage 
                                height={200} 
                                once={true} 
                                offset={400}
                                {...imgProps}
                            /> : <img {...imgProps} />
                        }
                        </Link>
                    </MetricsElement>
                </div>);
            })
        );
    }

    render() {
        let { ImageWrapper, className } = this.props;
        let settings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlideHeight: 200,
            initialSlideWidth: 300,
            ...this.controls(),
            lazyLoad: true,
            wrapAround: true,
            afterSlide: index => this.changeSlide(index),
            slideIndex: this.state.slideIndex
        }
        return (
            ImageWrapper
            ? <ImageWrapper images={this.imageList()}/>
            : (
                <div className={`prod-img${className ? ' ' + className : '' }`}>
                    <div className='product-img-slider'>
                        {this.props.images.length > 1 ?
                            <Carousel {...settings} ref={carousel=>this.carousel = carousel}>{this.imageList()}</Carousel> :
                            this.imageList()
                        }
                    </div>
                </div>
            )
        );
    }
}

export default OptimizeProductImageWrapper(ProductImage);
